import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';

export const styles = StyleSheet.create({
	trigger: {
		position: 'relative',
		width: 30,
		height: 30,
		minWidth: 30,
		padding: 0,
		borderRadius: THEME.common.borderRadius,
		color: 'var(--ink-muted)',
		':hover': {
			background: 'var(--hover)',
			color: 'var(--ink)',
		},
	},
	badge: {
		right: -2,
		top: -2,
	},
	content: {
		width: 340,
		padding: SPACE[8],
	},
	header: {
		padding: `${SPACE[4]}px ${SPACE[8]}px ${SPACE[8]}px`,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
	},
	empty: {
		padding: SPACE[8],
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
	list: {
		listStyle: 'none',
		margin: 0,
		padding: 0,
		maxHeight: 360,
		overflowY: 'auto',
	},
	row: {
		width: '100%',
		height: 'auto',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		gap: SPACE[4],
		padding: SPACE[8],
		textAlign: 'left',
		fontWeight: THEME.typography.fontWeights.standard,
	},
	rowTop: {
		display: 'flex',
		justifyContent: 'space-between',
		gap: SPACE[8],
	},
	name: {
		...THEME.common.truncate,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
	},
	time: {
		flexShrink: 0,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},
	company: {
		...THEME.common.truncate,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},
	snippet: {
		...THEME.common.truncate,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
	},
});
